<style lang="scss" scoped>
.style_one {
    .description {
        color: #8e8f91;
    }
    .link-list {
        a {
            @apply mx-8 text-button rounded-button border text-white border-yellow bg-yellow font-bold px-40 py-24 transition-colors hover:bg-transparent hover:text-yellow;
        }
    }
}
.style_two {
    @media (min-width: 1024px) {
        @apply bg-blue;
        border-radius: 90px;
        padding: 40px 0 40px 60px;

        img {
            position: absolute;
            top: -180px;
            right: -20px;
            width: 520px;
            height: auto;
        }
    }
    @media (min-width: 1136px) {
        padding: 80px 0px 80px 120px;
    }
    .description {
        opacity: 0.8;
    }
    .link-list {
        a {
            @apply mx-8 text-button rounded-button border text-dark border-white bg-white font-bold px-40 py-24 transition-colors hover:bg-transparent hover:text-white;
        }
    }
}
.description {
    ::v-deep ol,
    ::v-deep ul {
        list-style: disc;
        margin: 18px 0;
        padding: 0 0 0 20px;
    }
}
img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    max-width: 548px;
    max-height: 674px;
}
</style>

<template>
    <section class="container">
        <div :class="data.style">
            <div class="grid grid-cols-2 gap-60 lg:gap-120">
                <div v-animate.fade="'slide-up'" delay="1" class="relative flex justify-center col-span-2 lg:col-span-1" :class="{ 'lg:order-2': data.image_position === 'left', 'lg:order-1': data.image_position !== 'left' }">
                    <img :data-src="data.image.url" :alt="data.image.alt" class="lazyload" />
                </div>
                <div v-animate.fade="'slide-up'" class="flex justify-center flex-col col-span-2 lg:col-span-1" :class="{ 'lg:order-1': data.image_position === 'left', 'lg:order-2': data.image_position !== 'left' }">
                    <div class="text-24 font-light mb-24 text-yellow"> {{ data.sub_title }}</div>
                    <h2 class="text-34 lg:text-64 font-medium  mb-24">
                        {{ data.title }}
                    </h2>
                    <div class="text-24 font-light mb-40 description" v-html="data.content"></div>
                    <div class="link-list flex flex-wrap -mx-8">
                        <a v-for="(linkList, index) in data.links" :key="index" :href="linkList.link.url" :target="linkList.link.target === '0' ? '_self' : '_blank'" class="">{{ linkList.link.title }}</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        data: {
            required: true,
            default: () => ({
                id: "",
                title: "",
                content: ""
            })
        }
    }
};
</script>
